if (!customElements.get('pickup-icon')) {
  customElements.define('pickup-icon', class PickupIcon extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.variantSelects = document.querySelector('variant-selects, variant-radios');
      if (!this.variantSelects) return;

      // VariantSelects dispatches variant:change only when a variant resolves,
      // so the no-variant case is picked up from the change event instead.
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onSelectsChange = this.onSelectsChange.bind(this);

      document.addEventListener('variant:change', this.onVariantChange);
      this.variantSelects.addEventListener('change', this.onSelectsChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariantChange);
      if (this.variantSelects) this.variantSelects.removeEventListener('change', this.onSelectsChange);
      this.bound = false;
    }

    onVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant || !variant.available) return this.setAvailable(false);

      this.dataset.variantId = variant.id;
      this.fetchAvailability(variant.id);
    }

    // Runs after VariantSelects' own handler on the same element, so
    // currentVariant already reflects the new selection.
    onSelectsChange() {
      if (!this.variantSelects.currentVariant) this.setAvailable(false);
    }

    fetchAvailability(variantId) {
      // Same endpoint the stock pickup-availability element uses. The section
      // renders nothing when no location offers pick-up for the variant, and
      // flags whether the closest one can actually fulfil it.
      let url = `${window.routes.root_url}/variants/${variantId}/?section_id=pickup-availability`;
      url = url.replace('//', '/');

      this.request = variantId;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          if (this.request !== variantId) return;

          const preview = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('pickup-availability-preview');

          this.setAvailable(preview !== null && preview.dataset.pickupAvailable === 'true');
        })
        .catch(() => {
          // Leave the icon as it is rather than claiming pick-up we can't confirm.
        });
    }

    setAvailable(available) {
      this.hidden = !available;
    }
  });
}